import React from 'react';
import { IonButton } from '@ionic/react';
import { ProgressBar } from '@/components/ui';
import { UserCertificationSummary } from '../../types/teamUserSummary';

const CURRENT_PROGRESS_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Current%20Progress.svg';

interface ProgressWidgetProps {
  certifications: UserCertificationSummary[];
}

export const ProgressWidget: React.FC<ProgressWidgetProps> = ({ certifications = [] }) => {
  // Calculate progress for each certification from coursesCompleted/coursesTotal
  const calculateProgress = (coursesCompleted: number, coursesTotal: number): number => {
    if (coursesTotal === 0) return 0;
    return Math.round((coursesCompleted / coursesTotal) * 100);
  };


  return (
    <div className="bg-white flex w-full sm:min-w-60 flex-col px-5 py-4 rounded-[10px] h-full">
      <div className="flex items-center">
        <div className="flex items-center gap-3">
          <img
            src={CURRENT_PROGRESS_ICON_URL}
            alt="Progress"
            className="w-8 h-8"
          />
          <div className="text-[#2D2D2D] text-base font-medium">
            Current Progress
          </div>
        </div>
      </div>

      {certifications.length === 0 ? (
        <div className="flex flex-1 flex-col justify-end mt-4">
          <div className="text-[#928881] text-base font-normal">
            0
          </div>
        </div>
      ) : (
        <div className={`flex flex-1 flex-col justify-end mt-4 space-y-3`}>
          {certifications.map((cert) => {
            const certProgress = calculateProgress(cert.coursesCompleted, cert.coursesTotal);
            return (
              <div key={cert.certificationId}>
                <div className="text-[#928881] text-sm font-normal mb-1">
                  {cert.name}
                </div>
                <ProgressBar
                  progress={certProgress}
                  maxValue={100}
                  showLabel={true}
                  label={`${certProgress}%`}
                  className="w-full justify-between"
                />
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
};
